import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../../../store/root-reducer';

import DoNotCallListDetailsTable from './do-not-call-list-details-table';

import {
  DoNotCallListPhoneNumber,
  GetDoNotCallListDetailsPayload,
  PaginationOptions,
} from '../../../../../../types/do-not-call-list';

import {
  clearPhoneNumbersSelection,
  onBulkSelectPhoneNumbers,
  selectAllPhoneNumbers,
  selectSinglePhoneNumber,
} from '../../../../do-not-call-slice';

const mapStateToProps = (state: RootState) => ({
  bulkSelectedPhoneNumbers: state.callDoNotContact.bulkSelectedPhoneNumbers,
  selectedPhoneNumbers: state.callDoNotContact.selectedPhoneNumbers,
  getDoNotCallListDetailsRequestStatus:
    state.callDoNotContact.getDoNotCallListDetailsRequest.status,
});

const mapDispatchToProps = {
  onBulkSelectPhoneNumbers: (payload: any) =>
    onBulkSelectPhoneNumbers(payload),
  selectAllPhoneNumbers: (payload: { rows: any[]; status: boolean }) =>
    selectAllPhoneNumbers(payload),
  clearPhoneNumbersSelection: () => clearPhoneNumbersSelection(),
  selectSinglePhoneNumber: (payload: { row: any; status: boolean }) =>
    selectSinglePhoneNumber(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  doNotCallListDetails: DoNotCallListPhoneNumber[];
  doNotCallListDetailsPaginationOptions: PaginationOptions;
  filters: Pick<GetDoNotCallListDetailsPayload, 'page' | 'limit' | 'search'>;
  onFiltersChange: (
    payload: Partial<GetDoNotCallListDetailsPayload>,
    resetSelection?: boolean,
  ) => void;
  onAction: (key: string, phoneNumber: DoNotCallListPhoneNumber) => void;
  isLoading: boolean;
  resetSelected: boolean;
  handleResetSelected: (value?: boolean) => void;
};

export default connector(DoNotCallListDetailsTable);
